import View from './view.js'
import { useDataValue, useDataChange } from 'Simple/Data.js'
import { useEffect } from 'react'

export default function Logic(props) {
  let chairs = useDataValue({
    context: 'resources',
    viewPath: props.viewPath,
    path: 'chairs',
  })

  let chairs_in_view = useDataValue({
    context: 'settings',
    viewPath: props.viewPath,
    path: 'chairs_in_view',
  })

  let change = useDataChange({
    context: 'settings',
    viewPath: props.viewPath,
    path: 'chairs_in_view',
  })

  useEffect(() => {
    if (!chairs_in_view) {
      change(Math.min(chairs.length, 5))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chairs_in_view, chairs])

  return <View {...props} />
}
